import { useLocation } from "@gatsbyjs/reach-router"
import { usePreviewEvent } from "../../hooks/data/useEvents"
import { BaseNewsPage, GatsbyNewsArticle } from "./BaseNewsPage"
import { LoadingRow } from "../Account/LoadingRow"
import { useEffect } from "react"
import { navigate } from "gatsby"
import { usePreviewNews } from "../../hooks/data/useNews"

export const NewsPreview: React.FC<{
  slug: string
}> = ({ slug }) => {
  const {data: newsData, isLoading} = usePreviewNews(slug) 

  useEffect(() => {
    if (!isLoading && !newsData) {
      navigate('/404')
    }
  }, [isLoading, newsData])

  const transformNewsData = (data: typeof newsData): GatsbyNewsArticle => {
    const gatsbyNewsArticle: GatsbyNewsArticle = {
      title: data?.attributes?.title!,
      slug: data?.attributes?.slug!,
      author: data?.attributes?.author!,
      publishedDate: data?.attributes?.publishedDate!,
      shortDescription: {
        data: {
          shortDescription: data?.attributes?.shortDescription!
        }
      },
      content: {
        data: {
          content: data?.attributes?.content!
        }
      },
      contactUsPubInfo: {
        data: {
          contactUsPubInfo: data?.attributes?.contactUsPubInfo!
        }
      },
      image: {
        url: data?.attributes?.image?.data?.attributes?.url!
      },
      video: {
        videoDescription: data?.attributes?.video?.videoDescription!,
        videoTitle: data?.attributes?.video?.videoTitle!,
        videoUrl: data?.attributes?.video?.videoUrl!
      }
    }

    return gatsbyNewsArticle
  }

  return (
    <>
      {isLoading && <LoadingRow />}
      {newsData && (
        <BaseNewsPage data={{
          strapiNews: transformNewsData(newsData)
        }} />
      )}
    </>
  )
}

// export const Head: HeadFC = ({ data }) => {
//   const seoDefaultData = useSiteMetadata()
//   return (
//     <>
//       <Seo {...seoDefaultData} title={'Events | Hesburgh Libraries'} />
//       <StructuredData {...seoDefaultData} events={data.allStrapiEvent.nodes} />
//     </>
//   )
// }

export default NewsPreview